// API工具函数，自动处理token

export function getToken(): string | null {
  return localStorage.getItem('token');
}

export function setToken(token: string): void {
  try {
    localStorage.setItem('token', token);
    // 验证是否保存成功
    const saved = localStorage.getItem('token');
    if (saved !== token) {
      console.error('Failed to save token to localStorage! Expected:', token, 'Got:', saved);
    } else {
      console.log('Token successfully saved to localStorage');
    }
  } catch (e) {
    console.error('Error saving token to localStorage:', e);
    throw e;
  }
}

export function removeToken(): void {
  localStorage.removeItem('token');
}

export function getUser(): any | null {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  }
  return null;
}

export function setUser(user: any): void {
  try {
    const userStr = JSON.stringify(user);
    localStorage.setItem('user', userStr);
    // 验证是否保存成功
    const saved = localStorage.getItem('user');
    if (saved !== userStr) {
      console.error('Failed to save user to localStorage! Expected:', userStr, 'Got:', saved);
    } else {
      console.log('User successfully saved to localStorage');
    }
  } catch (e) {
    console.error('Error saving user to localStorage:', e);
    throw e;
  }
}

export function removeUser(): void {
  localStorage.removeItem('user');
}

// 带token的fetch请求
export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getToken();
  const headers = new Headers(options.headers);
  
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  
  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json');
  }
  
  const response = await fetch(url, {
    ...options,
    headers,
  });
  
  // 如果token过期，清除本地存储并跳转到登录页
  if (response.status === 401) {
    const data = await response.json().catch(() => ({}));
    if (data.error === 'invalid_token' || data.error === 'no_token') {
      removeToken();
      removeUser();
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
  }
  
  return response;
}

// 验证token是否有效（不自动清除token，由调用方决定）
export async function verifyToken(): Promise<boolean> {
  const token = getToken();
  if (!token) {
    return false;
  }
  
  try {
    // 直接使用fetch，不使用apiFetch，避免在验证失败时清除token
    const response = await fetch('/api/auth/verify', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    
    if (response.ok) {
      const data = await response.json();
      return data.ok === true;
    }
    return false;
  } catch (e) {
    return false;
  }
}
